import React, { useState, useEffect } from 'react';
import InputField from './InputField'; // Adjust the path according to your file structure
import {  useDispatch } from 'react-redux';
import { setUnavailableTimeSlots } from '../../redux/eventSlice';
import { intervalstimeslotAPI } from '../../api/event.service';
import { mindate , maxdate, timeSlotString, combineDateTime } from '../../utils/util';

interface Field {
  date: string;
  options:  { value: string, label: string,isChecked: boolean  }[];
  minDate: string;
  maxDate: string;
  index:number;
}


function DynamicTextTimeInterval(props:{newEvent:any, eventObject:any}) {

    const { newEvent, eventObject } = props;
    const minDate = mindate();
    const maxDate = maxdate(Number(newEvent.scheduleDays));
    const [timeslots, setTimeslots] = useState<string[]>([]);
    const [fields, setFields] = useState<Field[]>([{ date: newEvent.date, options: [],minDate:minDate, maxDate:maxDate ,index:0}]);
    const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      try {

        const response = await intervalstimeslotAPI(newEvent);
        const data = response;
        setTimeslots(data.availableTimeslots);
        let newFields:Field[] =[];
        if(eventObject && eventObject.unavailableTimeSlots && eventObject.unavailableTimeSlots.length > 0 ) {
    
            const unavailableSlots = transformData(eventObject.unavailableTimeSlots);
            let index = 0;
              eventObject.unavailableTimeSlots.forEach((timeslot:string) => {
                dispatch(setUnavailableTimeSlots({value:timeslot,status:true}));
              });

                Object.entries(unavailableSlots).forEach(([date, timeslots]) => {
                  index = index + 1;    
                  const transformedData = data.availableTimeslots.map((timeslot:string, index:number) => ({
                    value: timeSlotString(`${timeslot}`,Number(newEvent.duration)),
                    label: timeslot,
                    isChecked: Array.isArray(timeslots) && timeslots.includes(timeSlotString(`${timeslot}`,Number(newEvent.duration))) ? true : false
                  }));
                  newFields.push({ date: convertDateFormat(date), options: transformedData, index:index,minDate:minDate,maxDate:maxDate});
                });

            setFields(newFields);

        } else {
          const transformedData = data.availableTimeslots.map((timeslot:string, index:number) => ({
            value: timeSlotString(`${timeslot}`,Number(newEvent.duration)),
            label: timeslot,
            isChecked: false
          }));
          setFields(currentFields => 
            currentFields.map(field => ({
              ...field,
              index:1,
              options: JSON.parse(JSON.stringify(transformedData))
            }))
          );
        }

        
      } catch (error) {
        // Error: 'Error fetching data:', error);
      }
    };

    fetchData();
  }, []);


  const addField = () => {
    const transformedData = timeslots.map((timeslot:string, index:number) => ({
      value: timeSlotString(`${timeslot}`,Number(newEvent.duration)),
      label: timeslot,
      isChecked:  false
    }))
    const index = fields.length;
    const newFields = [...fields, { date: '', options: JSON.parse(JSON.stringify(transformedData)), minDate:minDate,maxDate:maxDate,index:index+1}];
    setFields(newFields);
  };

  const removeField = () => {
    if (fields.length > 1) {
      const newFields = fields.slice(0, -1);
      setFields(newFields);
    }
  };

  const handleTimeChange = (index:number,  value:string) => {
    const updatedFields = fields.map((field, idx) => {
      if (idx === index) {
        return { ...field, date: value };
      }
      return field;
    });

    setFields(updatedFields);
  };

  const handleCheckboxChange = (optionValue: string,isChecked:boolean,date:string,index:number) => {

  setFields(currentFields => 
    currentFields.map((field, fieldIndex) => {
      if (field.index === index) {
        return {
          ...field,
          options: field.options.map(option =>
            option.value === optionValue ? { ...option, isChecked: isChecked } : option
          )
        };
      }
      return field;
    })
  ); 
    const timeSlots = combineDateTime(optionValue,date);
    dispatch(setUnavailableTimeSlots({value:timeSlots,status:isChecked}));
    
  };

  const transformData = (data:string[]) => {
    const groupedByDate:any =[];
  
    data.forEach((item:string) => {
      const parts = item.split('-');
      const date = parts.slice(0, 3).join('-'); 
      const startTime = parts.slice(3, 5).join('-');
      const endTime = parts.slice(5).join('-'); 
      if (!groupedByDate[date]) {
        groupedByDate[date] = [];
      }
      groupedByDate[date].push(`${startTime}-${endTime}`);
    });
  
    // Sort the dates
    return groupedByDate;
  }; 
  const convertDateFormat = (dateString:string) =>{
    const parts = dateString.split('-');
    return `${parts[2]}-${parts[1]}-${parts[0]}`;
  }
  return (
    <div>
      {fields.map((field, index) => (
        <div key={index} className="mt-7 grid grid-cols-1 gap-3 md:grid-cols-2">
          <InputField
            extra="mb-3"
            label="Date Time"
            placeholder="dd:mm:yyyy"
            id={`time-from-${index}`}
            minDate={field.minDate}
            value={field.date}
            maxDate={field.maxDate}
            type="date"
            onChange={(e:any) => handleTimeChange(index, e.target.value)}
            />
        <div className="mb-3">
          <label htmlFor={`time-checkbox-${index}`} className="text-sm text-navy-700 dark:text-white ml-3 font-bold">
            {'Time Interval'}
          </label>
          <div id={`${index}`} className="mt-2 w-full max-h-[200px] overflow-y-auto rounded-xl border p-3">
              { field.options.length > 0 ?         field.options.map((option) => (
                  <div key={option.value} className="flex items-center mb-2">
                    <input
                      type="checkbox"
                      id={`checkbox-${option.value}`}
                      checked={option.isChecked}
                      onChange={(e) => handleCheckboxChange(option.value,e.target.checked,field.date,field.index)}
                      className="mr-2"
                    />
                    <label htmlFor={`checkbox-${option.value}`} className="font-semibold text-gray-700">
                      {option.label}
                    </label>
                  </div>
              )) : null }
          </div>
        </div>
      </div>
      ))}

      <button onClick={addField} className="mt-4 px-4 py-2 rounded bg-blue-500 text-white">+</button>
      <button onClick={removeField} className="mt-4 ml-2 px-4 py-2 rounded bg-red-500 text-white">-</button>
    </div>
  );
}

export default DynamicTextTimeInterval;
